// export const requestUrl = "https://47.108.185.159:8080" // 后端地址  
// export const requestUrl = "http://192.168.101.146:8080" // 后端地址
// export const requestUrl = "https://store.serviceli.cn" // 线上后端地址
export const requestUrl = "https://test-store.serviceli.cn" // 测试后端地址
export const baseUrl = "https://4b0942ae.r7.cpolar.top/" // 二维码跳转域名

// 支付宝配置
// export const appId = '2021006119642169' // 测试
// export const appId = requestUrl.includes('test-store')?'2021006119642169':'2021005132665908' // 正式

// 微信配置
export const wxAppId = 'wx28352dad2b81a677' // 微信开放平台/公众号的AppId
 export const AppId = 'wx8f0f01feff85f2c7' // 小程序
export const wxOAuthRedirectUri = window.location.origin + '/#/wechat_callback' // 微信OAuth回调地址

//安全发 
export const safeSendType = '1'  // 1 安全发 2 非安全发